<template>
  <div class="asc-subscription-center">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'AscSubscriptionCenter',
}
</script>
